/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import { appMuiTheme, getAppThemeMode } from "theme/appTheme.js";
import { withTheme } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import dashboardRoutes from "routes/dashboard.jsx";
import advisorDashboardRoutes from "routes/advisorDashboard.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";

// import image from "assets/img/sdg-bg.png";

import { staticData } from "config.js";
import { Authenticated } from "containers/authenticated.js";
import { ThemeContext } from "containers/theme.jsx";

const switchRoutes = (routesList) => {
  return (
    <Switch>
      {routesList.map((prop, key) => {
        if (prop.redirect)
          return <Redirect from={prop.path} to={prop.to} key={key} />;
        return <Route path={prop.path} component={prop.component} key={key} />;
      })}
    </Switch>
  );
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }

  setThemeMode = themeMode => {
    localStorage.setItem("themeMode", themeMode);
    window.location.reload();
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/maps";
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      const ps = new PerfectScrollbar(this.refs.mainPanel);
    }
    window.addEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFunction);
  }
  render() {
    const { classes, ...rest } = this.props;
    let isAdvisor =
      this.props.user &&
      this.props.user.roles &&
      this.props.user.roles.filter(role => role === "ADVISOR");
    let routesList = dashboardRoutes;
    if (isAdvisor && isAdvisor.length > 0) {
      routesList = advisorDashboardRoutes;
    }
    return (
      <ThemeContext.Provider value={{ themeMode: getAppThemeMode(), setThemeMode: this.setThemeMode }}>
        <ThemeProvider theme={appMuiTheme}>
          <div className={classes.wrapper}>
            <Sidebar
              routes={routesList.filter(prop => prop.hide !== true)}
              logoText={staticData.company.logoText}
              logo={staticData.company.logoURL}
              // image={image}
              handleDrawerToggle={this.handleDrawerToggle}
              open={this.state.mobileOpen}
              color="blue"
              {...rest}
            />
            <div className={classes.mainPanel} ref="mainPanel">
              <Header
                routes={routesList}
                handleDrawerToggle={this.handleDrawerToggle}
                {...rest}
              />
              {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
              {this.getRoute() ? (
                <div className={classes.content}>
                  <div className={classes.container}>
                    {switchRoutes(routesList)}
                  </div>
                </div>
              ) : (
                <div className={classes.map}>{switchRoutes(routesList)}</div>
              )}
              {this.getRoute() ? <Footer /> : null}
            </div>
          </div>
        </ThemeProvider>
      </ThemeContext.Provider>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
};

class AppAuthenticated extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Authenticated>
        <App {...this.props} />
      </Authenticated>
    );
  }
}

export default withTheme(withStyles(theme => {
  theme.palette.type = getAppThemeMode();
  return dashboardStyle(theme);
})(AppAuthenticated));
